const isArray = <T>(values: T): T extends never[] ? boolean : boolean => {
  return values ? Array.isArray(values) : false;
};

export default isArray;
